var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3115 5101 c-27 -13 -191 -171 -501 -482 -451 -453 -462 -465 -472 -514 -12 -55 -2 -123 23 -162 39 -60 114 -102 180 -103 82 0 125 33 390 299 l250 251 5 -1272 5 -1273 27 -38 c14 -22 43 -51 65 -65 33 -23 48 -27 113 -27 65 0 80 4 113 27 22 14 51 43 65 65 l27 38 5 1273 5 1272 250 -251 c265 -266 308 -299 390 -299 66 1 141 43 180 103 25 39 35 107 23 162 -10 49 -21 61 -472 514 -310 311 -474 469 -501 482 -22 10 -60 19 -85 19 -25 0 -63 -9 -85 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1832 3394 c-44 -23 -85 -64 -106 -107 -15 -32 -16 -146 -16 -1298 l0 -1264 -257 257 c-271 271 -307 298 -388 298 -66 0 -141 -43 -180 -103 -25 -39 -35 -107 -23 -162 10 -49 21 -61 472 -514 310 -311 474 -469 501 -482 51 -24 119 -24 170 0 27 13 191 171 501 482 451 453 462 465 472 514 12 55 2 123 -23 162 -39 60 -114 102 -180 103 -82 0 -125 -33 -390 -299 l-250 -251 -5 1272 -5 1273 -27 38 c-43 63 -92 91 -168 95 -46 2 -75 -2 -98 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.9a4b1affb930243d90fbbc8f61dfff95.svg";
export { ForwardRef as ReactComponent };